import BlogThirtyThreeContainer from "./container/BlogThirtyThreeContainer";
export default BlogThirtyThreeContainer;
